/* @flow */

import getDadosFormulario from './get-formulario';
import exibirErro from '../../utils/exibir-erro';
import mensagemSucesso from './mensagem-sucesso';
import getElementoPorId from '../../utils/get-elemento-por-id';
import cadastroContatos from './contatos-estabelecimento';
import cadastroEndereco from './endereco-estabelecimento';
import cadastroAplicativo from './aplicativo-estabelecimento';
import cadastroUrlsLojas from './urls-lojas';
import cadastroPackages from './packages';
import cadastroCobranca from './cadastro-cobranca';
import proximaEtapa from './proximaEtapa';
import loading from '../../utils/loading';
import ativacaoItensMenu from '../eventos-formularios/ativacao-itens-menu';
import api from '../../utils/api';
import getInputPorId from '../../utils/get-input-por-id';

export default class CadastroEmpresaPorEtapa {
    cadastrarEmpresa() {
        ativacaoItensMenu('pointer-events: none;');
        const form = getElementoPorId('formulario-empresa');
        const inputVendasSemPolling = getInputPorId('vendas-sem-polling');
        const inputUsaEstoque = getInputPorId('usa-estoque');


        form.onsubmit = async (e) => {
            const empresa = getDadosFormulario(form);
            empresa.vendasSemPolling = inputVendasSemPolling.checked === true ? '1' : '0';
            empresa.usaEstoque = inputUsaEstoque.checked === true ? '1' : '0';
            e.preventDefault();
            try {
                loading.show();
                const { data: { id } } = await api.criarEmpresa(empresa);
                loading.hide();
                mensagemSucesso('Empresa cadastrada com sucesso.');
                proximaEtapa('contatos');
                this.cadastrarEtapas(id);
            } catch (err) {
                exibirErro(err);
                loading.hide();
            }
        };
    }

    cadastrarEtapas(id: number) {
        ativacaoItensMenu('');
        cadastroContatos(id);
        cadastroEndereco(id);
        cadastroCobranca(id);
        cadastroAplicativo(id);
        cadastroUrlsLojas(id);
        cadastroPackages(id, () => {
            mensagemSucesso('Packages cadastradas');
            setTimeout(() => {
                window.location.href = 'https://admin.plom.com.br/empresas';
            }, 4000);
        });
    }
}
